let isGoogleTranslateDomPatchApplied = false;

export const applyGoogleTranslateDomPatch = () => {
  if (isGoogleTranslateDomPatchApplied || typeof window === "undefined") {
    return;
  }

  const originalRemoveChild = Node.prototype.removeChild;
  const originalInsertBefore = Node.prototype.insertBefore;

  Node.prototype.removeChild = function patchedRemoveChild(child) {
    try {
      return originalRemoveChild.call(this, child);
    } catch (error) {
      if (error?.name === "NotFoundError") {
        return child;
      }
      throw error;
    }
  };

  Node.prototype.insertBefore = function patchedInsertBefore(newNode, referenceNode) {
    try {
      return originalInsertBefore.call(this, newNode, referenceNode);
    } catch (error) {
      if (error?.name === "NotFoundError") {
        return this.appendChild(newNode);
      }
      throw error;
    }
  };

  isGoogleTranslateDomPatchApplied = true;
};
